import PropTypes from "prop-types"
import React from "react";
import { Link } from "gatsby";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  siteLogoLink: {
    color: "white",
    textDecoration: "none"
  },
  "site--logo-link": {
    extend: "siteLogoLink",
    "&:link, &:visited, &:hover, &active": {
      extend: "siteLogoLink"
    }
  }
})

const Header = ({ siteTitle }) => {

  const styles = useStyles();

  return (
    <header className="page--header bg-dark text-light mb-4 py-2">
      <div className="container">
        <h1 style={{fontSize: "1.5rem"}}>
            <Link to="/" className={styles["site--logo-link"]}>
              {siteTitle}
            </Link>
        </h1>
      </div>
    </header>
  );
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
